"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Event = void 0;
var create_entity_1 = require("../../utils/create-entity");
var event_details_layout_1 = require("../../components/entities/event-details-layout");
var graphql_1 = require("../../utils/graphql");
exports.Event = {
  name: 'Event',
  useConversation: true,
  useFollowers: true,
  groupName: 'Participate',
  useSites: true,
  useModerators: true,
  useConnections: true,
  useSlices: true,
  useSpaces: true,
  usePublishStatus: true,
  includeInSearch: true,
  autoRoutes: ['details', 'list', 'update', 'create'],
  usePlatformActivity: true,
  components: {
    details: event_details_layout_1.EventDetailsLayout
  },
  platformActivity: {
    tab: 'own'
  },
  filters: {
    fields: {
      types: {
        entityTypeName: 'EventType'
      }
    }
  },
  list: {
    hasSearch: true,
    banner: {
      content: 'Explore in-person and online {{EVENTS}}'
    },
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      sites { ...EntityValueFields }\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      description { plainTruncated: plain(truncate: { words: 50 }) plain ...ContentNodeFields }\n      sessions { id }\n    "], ["\n      sites { ...EntityValueFields }\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      description { plainTruncated: plain(truncate: { words: 50 }) plain ...ContentNodeFields }\n      sessions { id }\n    "])))
  },
  form: {
    fieldsMemoize: false,
    modal: {
      fill: true
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'sessions'
    }, {
      name: 'taxonomies',
      label: process.env.TAXONOMIES_LABEL || 'Challenges & Goals'
    }, {
      name: 'library'
    }, {
      name: 'activity'
    }, {
      name: 'community'
    }, {
      name: 'places'
    }, {
      name: 'content'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      startDate: {
        type: 'date',
        description: 'When does this {{EVENT}} start?',
        fieldSet: 'overview'
      },
      endDate: {
        type: 'date',
        description: 'When does this {{EVENT}} finish?',
        fieldSet: 'overview'
      },
      startDateTimeZone: {
        type: 'linked',
        entityTypeName: 'TimeZone',
        label: 'Start Date Time Zone',
        description: "Which {{TIME_ZONE}} applies to the start date?"
      },
      endDateTimeZone: {
        type: 'linked',
        entityTypeName: 'TimeZone',
        label: 'End Date Time Zone',
        description: "Which {{TIME_ZONE}} applies to the end date? Note: leave this blank if it's the same as the start date (this would likely only be different if the end date was beyond a daylight-savings change-over)."
      },
      title: {
        type: 'text',
        recommended: false
      },
      subtitle: {
        type: 'text',
        recommended: false
      },
      types: {
        type: 'linkedMultiple',
        entityTypeName: 'EventType',
        fieldSet: 'overview',
        description: "What type of {{EVENT}} is this?",
        recommended: false
      },
      banner: {
        type: 'banner',
        recommended: false
      },
      description: {
        type: 'description'
      },
      overview: {
        type: 'longText',
        recommended: false
      },
      sessionInfo: {
        type: 'longText',
        recommended: false
      },
      venues: {
        type: 'linkedMultiple',
        entityTypeName: 'Venue',
        fieldSet: 'overview'
      },
      files: {
        type: 'linkedMultiple',
        entityTypeName: 'FileAsset'
      },
      url: {
        type: 'url',
        fieldSet: 'overview',
        recommended: false
      },
      isVirtual: {
        type: 'boolean',
        label: 'Is Online?',
        description: "Is this an online-only {{EVENT}}?",
        recommended: false
      },
      colors: {
        type: 'linkedMultiple',
        entityTypeName: 'Color',
        recommended: false
      },
      sessions: {
        type: 'linkedTable',
        description: 'Create one or more {{SESSIONS}} for this {{EVENT}}',
        entityTypeName: 'Session',
        fieldSet: 'sessions'
      },
      roles: {
        type: 'linkedTable',
        entityTypeName: 'EventRole',
        label: '{{PEOPLE}}',
        description: "Are there any other key {{PEOPLE}} involved in this {{EVENT}}?",
        fieldSet: 'community'
      },
      organisationRoles: {
        type: 'linkedTable',
        entityTypeName: 'OrganisationEventRole',
        label: '{{ORGANISATIONS}}',
        description: "Are there any {{ORGANISATIONS}} involved in this {{EVENT}}?",
        fieldSet: 'community'
      },
      challenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        fieldSet: 'taxonomies'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'taxonomies'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'taxonomies'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'taxonomies'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'taxonomies'
      },
      locations: {
        type: 'linkedMultiple',
        entityTypeName: 'Location',
        fieldSet: 'places'
      },
      economies: {
        type: 'linkedMultiple',
        entityTypeName: 'Economy',
        fieldSet: 'places'
      },
      quotes: {
        type: 'linkedMultiple',
        entityTypeName: 'Quote',
        fieldSet: 'library'
      },
      images: {
        type: 'linkedMultiple',
        entityTypeName: 'ImageAsset',
        fieldSet: 'library'
      },
      links: {
        type: 'linkedMultiple',
        entityTypeName: 'Link',
        fieldSet: 'library'
      },
      videos: {
        type: 'linkedMultiple',
        entityTypeName: 'Video',
        fieldSet: 'library'
      },
      documents: {
        type: 'linkedMultiple',
        entityTypeName: 'Document',
        fieldSet: 'activity'
      }
    })
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      id\n      name\n      banner { ...EntityValueFields }\n      slug\n      description { id text html }\n      overview { id text html }\n      sessionInfo { id text html }\n      startDate\n      endDate\n      isVirtual\n      url\n      venue { ...EntityValueFields }\n      types { ...EntityValueFields }\n      places { id name slug latitude longitude address1 address2 banner { id name slug title description { text } alternateText openGraph { id image { id url } } } city { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } } }\n      sessions { \n        ...EntityValueFields \n        startDate \n        endDate \n        startDateTimeZone { ...EntityValueFields abbreviation utcOffset }\n        endDateTimeZone { ...EntityValueFields abbreviation utcOffset }\n        files { ...FileAssetValueFields }\n        description { id text }\n        presenters { ...EntityValueFields }\n        colors { ...EntityValueFields value }\n        groups { ...EntityValueFields }\n        venue { ...EntityValueFields }\n        room { ...EntityValueFields shortName }\n      }\n      \n      sites { ...EntityValueFields }\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n\n      files { ...FileAssetValueFields }\n      locations { ...EntityValueFields }\n      economies { ...EntityValueFields }\n      sdgs { ...EntityValueFields }\n      chapters { ...EntityValueFields }\n\n      links { id }\n      documents { id }\n      quotes { id }\n      roles { id }\n      organisationRoles { id }\n    "], ["\n      id\n      name\n      banner { ...EntityValueFields }\n      slug\n      description { id text html }\n      overview { id text html }\n      sessionInfo { id text html }\n      startDate\n      endDate\n      isVirtual\n      url\n      venue { ...EntityValueFields }\n      types { ...EntityValueFields }\n      places { id name slug latitude longitude address1 address2 banner { id name slug title description { text } alternateText openGraph { id image { id url } } } city { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } } }\n      sessions { \n        ...EntityValueFields \n        startDate \n        endDate \n        startDateTimeZone { ...EntityValueFields abbreviation utcOffset }\n        endDateTimeZone { ...EntityValueFields abbreviation utcOffset }\n        files { ...FileAssetValueFields }\n        description { id text }\n        presenters { ...EntityValueFields }\n        colors { ...EntityValueFields value }\n        groups { ...EntityValueFields }\n        venue { ...EntityValueFields }\n        room { ...EntityValueFields shortName }\n      }\n      \n      sites { ...EntityValueFields }\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n\n      files { ...FileAssetValueFields }\n      locations { ...EntityValueFields }\n      economies { ...EntityValueFields }\n      sdgs { ...EntityValueFields }\n      chapters { ...EntityValueFields }\n\n      links { id }\n      documents { id }\n      quotes { id }\n      roles { id }\n      organisationRoles { id }\n    "])))
  }
};
var templateObject_1, templateObject_2;